import { Box, Checkbox, FormControlLabel } from "@outschool/backpack";
import { Search } from "@outschool/business-rules";
import {
  ensureContiguousSearchClassSizeSelection,
  useActivityString,
} from "@outschool/ui-components-website";
import isEqual from "lodash/isEqual";
import React from "react";

import { Filter } from "../Filter";
import { ListingChildFilterProps } from "./ListingFilters";

const { getClassSizesFromCapacityFilter, getCapacityFiltersFromClassSize } =
  Search;

export default function ClassSizeFilter({
  searchFilters,
  onChange,
}: ListingChildFilterProps) {
  const { classSizeOptions } = useActivityString();
  const selectedClassSizes = isEqual(searchFilters, {})
    ? []
    : getClassSizesFromCapacityFilter(searchFilters);

  const handleSizeToggle = (sizeValue: Search.ClassSize) => {
    let newSelectedSizes: Search.ClassSize[];

    if (selectedClassSizes.includes(sizeValue)) {
      // Remove the size
      newSelectedSizes = selectedClassSizes.filter(size => size !== sizeValue);
    } else {
      // Add the size
      newSelectedSizes = [...selectedClassSizes, sizeValue];
    }

    const finalSelectedValue = ensureContiguousSearchClassSizeSelection(
      selectedClassSizes,
      newSelectedSizes,
    );

    if (finalSelectedValue.length === 0) {
      onChange?.({});
      return;
    }

    const filterValue = getCapacityFiltersFromClassSize(finalSelectedValue);
    onChange?.(filterValue);
  };

  return (
    <Filter showTopBorder={false}>
      <Box
        sx={{
          padding: "12px 24px 24px 0px",
        }}
      >
        {classSizeOptions.map(option => (
          <FormControlLabel
            key={option.value}
            control={
              <Checkbox
                checked={selectedClassSizes.includes(option.value)}
                onChange={() => handleSizeToggle(option.value)}
              />
            }
            label={option.label}
          />
        ))}
      </Box>
    </Filter>
  );
}
